import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IKeyContact} from "../interfaces/ikeycontact";
import { KeyContactService } from "../services/keycontact.service";
import { Observable } from "rxjs";

@Injectable()
export class KeyContactResolver implements Resolve<IKeyContact> {

    constructor(private keyContactService: KeyContactService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IKeyContact> {
        return this.keyContactService.getKeyContact(route.params["id"]);
    }
}
